import { createSlice } from "@reduxjs/toolkit";

const leaveSlice = createSlice({
    name: "leave",
    initialState: {

    },
    reducers: {
        applyLeave: () => { },
        updateLeave: () => { },
        getLeaves: () => { },
        getAllLeaves: () => { },
        deleteLeaves: () => { }
    }
});

export const {
    applyLeave,
    updateLeave,
    deleteLeaves,
    getLeaves,
    getAllLeaves
} = leaveSlice.actions

export default leaveSlice.reducer